






import { ConfigPreview } from './config-preview';
export default ConfigPreview;
